function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

var heart = {
  "id": "heart",
  "symbol": "<symbol id=\"heart\" viewBox=\"0 0 20 18\" style=\"fill: currentColor\"><path d=\"M18.4746 9.61628L11.0914 17.2503C10.6081 17.75 9.81729 17.75 9.33404 17.2503L1.95076 9.61628C-0.190675 7.40038 -0.072443 3.73591 2.30309 1.67972C4.37779 -0.116044 7.55262 0.207918 9.46195 2.17906L10.2145 2.95596L10.967 2.17906C12.8763 0.207956 16.0511 -0.116044 18.1257 1.6796C20.5014 3.73576 20.6197 7.4003 18.4746 9.61628Z\" /></symbol>"
};

export { heart };
